import { render, staticRenderFns } from "./facet-library.vue?vue&type=template&id=2a32834e&"
import script from "./facet-library.ts?vue&type=script&lang=ts&"
export * from "./facet-library.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports